import { render } from "./DownloadCta.vue?vue&type=template&id=5ace0658&scoped=true&ts=true"
import script from "./DownloadCta.vue?vue&type=script&lang=ts"
export * from "./DownloadCta.vue?vue&type=script&lang=ts"

import "./DownloadCta.vue?vue&type=style&index=0&id=5ace0658&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ace0658"]])

export default __exports__